import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 53D81A11-D8FF-46F4-A0CB-B7F668BA720D
 * name star
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star.svg
 * tags
 * - Shape 
 */
export const StarIcon = createSvgIcon(<><path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" /></>, 'StarIcon');
export default StarIcon